import { Charge } from '@willow/types-iso';

/**
 * Filters charges that don't have a CHARGED status
 * By default deferred charges are not included
 */
export function getChargesDue<T extends Pick<Charge, 'status' | 'isDeferred'>>(
  charges: T[],
  includeDeferred?: boolean,
): T[] {
  return charges.filter((charge) => {
    const isChargedStatus = charge.status === 'CHARGED';
    return includeDeferred ? isChargedStatus : isChargedStatus && !charge.isDeferred;
  });
}

/*
 * getLateFeesFirstThenOtherChargesDue
 *
 * Return oldest to newest late fees first, then oldest to newest (advances and non late fees) sorted by charge date
 */
export function getLateFeesFirstThenOtherChargesDue(charges: Charge[], includeDeferred?: boolean): Charge[] {
  const nonDeferredCharges = getChargesDue(charges, includeDeferred);

  const sorted = nonDeferredCharges.slice().sort((a, b) => a.chargeDate.getTime() - b.chargeDate.getTime());
  return [
    ...sorted.filter((charge) => charge.type === 'fee' && charge.lineItems.some((item) => item.type === 'LATE')),
    ...sorted.filter(
      (charge) =>
        charge.type === 'advance' || (charge.type === 'fee' && charge.lineItems.every((item) => item.type !== 'LATE')),
    ),
  ];
}
